import { createEnvelopeSource } from './create-envelope-source';

/**
 * Six12-purchases KPI source. National + RPP-only (no province breakdown):
 * `regionGrain: 'national'`. The card is `split` (RPP vs full app); the Full
 * app side names a `metricSuffix` the endpoint never emits, so it renders
 * unavailable by design.
 */
export const six12PurchasesSource = createEnvelopeSource({
    label: 'Six12 purchases',
    endpoint: 'analytics/six12/purchases',
    regionGrain: 'national',
    metrics: [
        { id: 'individuals', label: 'In-store individuals', type: 'scalar' },
        { id: 'transactions', label: 'Lift transactions', type: 'scalar' },
        {
            id: 'revenue',
            label: 'Revenue via LIFT',
            type: 'scalar',
            isCurrency: true,
        },
        // Ratios, not scalars: both are averages the endpoint carries as a
        // numerator/denominator pair, so a period with nothing priced answers
        // `rate: null` and the card reads unavailable instead of a measured $0.
        // The `number` form shows the `rate`, with `isCurrency` picking the
        // unit, so these render as dollars and not as a percentage.
        {
            id: 'avgSpend',
            label: 'Avg. spent per transaction',
            type: 'ratio',
            isCurrency: true,
        },
        { id: 'itemsPerBasket', label: 'Items in basket', type: 'ratio' },
    ],
    forms: ['split', 'number'],
    split: {
        left: { label: 'RPP' },
        right: { label: 'Full app', metricSuffix: 'FullApp' },
    },
});
